import { cloneProviderClient, unwrap } from './cloneProviderClient';

export async function listProxies() {
  const response = await cloneProviderClient.get('/admin/proxies');
  return unwrap(response);
}

export async function addProxy({ host, port, username, password }) {
  const response = await cloneProviderClient.post('/admin/proxies', null, {
    params: { host, port, username, password },
  });
  return unwrap(response);
}

export async function setProxyErrorCount(host, port, value) {
  const response = await cloneProviderClient.patch(
    `/admin/proxies/${encodeURIComponent(host)}/${encodeURIComponent(port)}/error-count`,
    null,
    { params: { value } }
  );
  return unwrap(response);
}

export async function removeProxy(host, port) {
  const response = await cloneProviderClient.delete(
    `/admin/proxies/${encodeURIComponent(host)}/${encodeURIComponent(port)}`
  );
  return unwrap(response);
}

export async function rebalanceProxylessAccounts() {
  const response = await cloneProviderClient.post('/admin/proxies/rebalance');
  return unwrap(response);
}

export async function unassignProxyAccounts(host, port) {
  const response = await cloneProviderClient.post(
    `/admin/proxies/${encodeURIComponent(host)}/${encodeURIComponent(port)}/unassign`
  );
  return unwrap(response);
}

const proxiesService = {
  listProxies,
  addProxy,
  setProxyErrorCount,
  removeProxy,
  rebalanceProxylessAccounts,
  unassignProxyAccounts,
};
export default proxiesService;
